import React from 'react';
import { useTranslation } from 'react-i18next';
import { Combobox } from '@vwfs-bronson/bronson-react';
import { ComboboxOption, ComboboxState } from '@cp-shared-19/frontend-ui';
import { AllTimeframes, sortedTimeframes, Timeframe, timeframeTranslationMapping } from '../helper/Timeframe';

export type TimeframeSelectProps = {
    value: Timeframe | AllTimeframes;
    onChange: (value: Timeframe | AllTimeframes) => void;
};

export const TimeframeSelect: React.FC<TimeframeSelectProps> = ({ value, onChange }) => {
    const { t, i18n } = useTranslation('postbox');

    const optionElements = [
        {
            key: 'ALL',
            value: {
                textValue: t('filters.timeframe.select-items.all'),
                content: t('filters.timeframe.select-items.all'),
            },
        },
        ...sortedTimeframes.map(timeframe => ({
            key: timeframe,
            value: {
                textValue: t(`filters.timeframe.select-items.${timeframeTranslationMapping[timeframe]}`),
                content: t(`filters.timeframe.select-items.${timeframeTranslationMapping[timeframe]}`),
            },
        })),
    ];

    const defaultOption = optionElements.find(option => option.key === value) || optionElements[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectValueChange = (selected: any): void => {
        const selectedKey = selected?.[0]?.key as Timeframe | AllTimeframes | undefined;
        if (selectedKey && selectedKey !== value) {
            onChange(selectedKey);
        }
    };
    const defaultItem: ComboboxState = {
        value: [{ key: defaultOption.key, value: defaultOption.value.textValue }],
    };

    return (
        <>
            <label>{t('filters.timeframe.label')}</label>
            <Combobox
                key={i18n.language}
                testId={'TimeframeSelect'}
                onChange={selectValueChange}
                value={[(defaultOption as unknown) as ComboboxOption]}
                options={optionElements}
                defaultState={defaultItem}
                className="c-form-field--no-floating"
            />
        </>
    );
};
